import { combineReducers } from "@reduxjs/toolkit";

import { propertyContactsListingReducer } from "./propertyContactsSlice";

export const propertyContactsReducer = combineReducers({
  propertyContactsListing: propertyContactsListingReducer,
});
